/* Versione .webp delle immagini in /images (generate da scripts/images-webp.js).
   Se il file .webp non esiste, onImgError riporta l'immagine all'originale. */
export const webpSrc = (url) =>
  typeof url === "string" && url.startsWith("/images/") && /\.(png|jpe?g)$/i.test(url)
    ? url.replace(/\.(png|jpe?g)$/i, ".webp")
    : url;

export const onImgError = (original) => (e) => {
  if (original && e.currentTarget.src !== original) {
    e.currentTarget.src = original;
  }
};
